<template>
  <div>
    <el-button type="primary" size="small" @click="refresh()">刷新列表</el-button>
    <el-table :data="list" border style="width: 100%">
        <el-table-column prop="queue" label="队列" width="300">
        </el-table-column>
        <el-table-column prop="count" label="等待执行的任务数量">
        </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {getQueueInfo} from '../../../../api/company'

export default{
  data () {
    return {
      list: []
    }
  },
  methods: {
    getConfig () {
      let query = {}
      getQueueInfo(query).then(response => {
        this.list = response.data.data
        // this.list.forEach(function (item, index, array) {
        //   console.log(item)
        //   console.log(index)
        //   console.log(array)
        // })
      })
    },
    refresh () {
      this.getConfig()
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?30032756